<template>
  <div class="state-list-display-component-hoverbox" :style="positionForStateCount">
    {{ listOfStates }}
  </div>
</template>

<script>
  export default {
    props: ['stateAbbreviations'],
    computed: {
      listOfStates () {
        return this.stateAbbreviations.map(state => state.id).join(' | ');
      },

      // position the hoverbox relative to the parent as it grows in width per length
      positionForStateCount () {
        const length = this.stateAbbreviations.length;
        if (length > 32) {
          return 'left: 3%;';
        }
        return `left: ${68 - length * 2}%;`
      }
    }
  };
</script>

<style scoped>
  .state-list-display-component-hoverbox {
    position: absolute;
    border: 1px solid lightblue;
    box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.2);
    width: auto;
    padding: 1em;
    text-align: center;
    border-radius: 3px;
    background-color: white;
    z-index: 999;
    max-width: 94%;
  }
</style>
